import React, { useState} from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import GuestRoute from "./components/GuestRoute";

import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./pages/Home";
import { store } from "./store/store";
import Loader from "./components/Loader";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyOTP from "./pages/VerifyOTP";
import Panel from "./pages/Panel";
import Profile from "./pages/Profile";
import Exam from "./pages/Exam";
import Users from "./pages/Users";
import Exams from "./pages/Exams";
import FutureExams from "./pages/FutureExams";
import ExamTaker from "./pages/ExamTaker";
import PastExams from "./pages/PastExams";
import Results from "./pages/Results";
import Result from "./pages/Result";
import Reports from "./pages/Reports";
import ResultById from "./pages/ResultById";
import Videos from "./pages/Videos";
import RecoverPassword from "./pages/RecoverPassword";
import ChangePassword from "./pages/ChangePassword";
import TitleUpdater from "./services/TitleUpdater";
import Invoices from "./pages/Invoices";
import AboutUs from "./pages/AboutUs";
import Discounts from "./pages/Discounts";
import Bundles from "./pages/Bundles";
import Files from "./pages/Files";
import Products from "./pages/Products";

function AppContent() {
  const theme = extendTheme({
    direction: "rtl", // Set the direction to RTL
  });
  const [loading,setLoading] = useState(false);
  if (loading) return <Loader />;
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <TitleUpdater />
        <Routes>
          <Route path="/" element={<GuestRoute element={<Home />} />} />
          <Route path="/RecoverPassword" element={<GuestRoute element={<RecoverPassword />} />} />
          <Route path="/ChangePassword" element={<GuestRoute element={<ChangePassword />} />} />
          <Route path="/login" element={<GuestRoute element={<Login />} />} />
          <Route
            path="/register"
            element={<GuestRoute element={<Register />} />}
          />
          <Route
            path="/verifyOTP"
            element={<PrivateRoute element={<VerifyOTP />} />}
          />
          <Route path="/panel" element={<PrivateRoute element={<Panel />} />} />
          <Route path="/AboutUs" element={<PrivateRoute element={<AboutUs />} />} />
          <Route
            path="/profile"
            element={<PrivateRoute element={<Profile />} />}
          />
          <Route path="/users" element={<PrivateRoute element={<Users />} />} />
          <Route path="/exams" element={<PrivateRoute element={<Exams />} />} />
          <Route path="/bundles" element={<PrivateRoute element={<Bundles />} />} />
          <Route path="/files" element={<PrivateRoute element={<Files />} />} />
          <Route path="/Invoices" element={<PrivateRoute element={<Invoices />} />} />
          <Route
              path="/Invoices/:productType/:productId"
              element={<PrivateRoute element={<Invoices />} />}
          />
          <Route
              path="/Products/:Type"
              element={<PrivateRoute element={<Products />} />}
          />
          <Route path="/Discounts" element={<PrivateRoute element={<Discounts />} />} />
          <Route
            path="/exam/:examId"
            element={<PrivateRoute element={<Exam />} />}
          />
          <Route
            path="/FutureExams"
            element={<PrivateRoute element={<FutureExams />} />}
          />
          <Route
            path="/PastExams"
            element={<PrivateRoute element={<PastExams />} />}
          />
          <Route
            path="/Results"
            element={<PrivateRoute element={<Results />} />}
          />
          <Route
            path="/Reports"
            element={<PrivateRoute element={<Reports />} />}
          />
          <Route
              path="/Reports/:examId"
              element={<PrivateRoute element={<Reports />} />}
          />
          <Route
            path="/Result/:examId"
            element={<PrivateRoute element={<Result />} />}
          />
          <Route
            path="/ResultById/:userId/:examId"
            element={<PrivateRoute element={<ResultById />} />}
          />
          <Route
            path="/Videos/:examId"
            element={<PrivateRoute element={<Videos />} />}
          />
          <Route
            path="/ExamTaker"
            element={<PrivateRoute element={<ExamTaker />} />}
          />
        </Routes>
      </Router>
      <ToastContainer rtl />
    </ChakraProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
